// extracted by mini-css-extract-plugin
export var text = "_65-0";